import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd4b228a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "summary" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "options-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, " 工单汇总概况 ")
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  class: "icon",
  "aria-hidden": "true"
}
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "text" }

import {
  computed, reactive, ref, watch, onMounted, onUnmounted,
} from 'vue';

import { useRouter, } from 'vue-router';
import { useStore, } from 'vuex';
import moment, { Moment, } from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const router = useRouter();

/*
 *  //运单总量
 *  total;
 *  //完成率
 *  complete;
 *  //待分配
 *  distribute;
 *  //待审核
 *  audit;
 *  //待办结
 *  transferre;
 *  //响应时间
 *  resp;
 *  //处理时间
 *  deal;
 */
// NODE 主体列表配置
const options = ref<any>([]);

const setOption = (statisticsSummary: any) => {
  options.value = [
    {
      // 布局，前四横向，后三纵向
      layout: 'crosswise',
      // 前4标题
      title: '工单总量',
      // 后3标题
      name: null,
      // 前4左侧图片
      iconfont: 'icon-ticket-tips1',
      color: 'title blue',
      value: statisticsSummary.total ?? 0,
      router: 'all',
    },
    {
      layout: 'crosswise',
      title: '待分配',
      name: null,
      iconfont: 'icon-ticket-tips2',
      color: 'title blue',
      value: statisticsSummary.distribute ?? 0,
      router: 'toBeAssigned',
    },
    {
      layout: 'crosswise',
      title: '待办结',
      name: null,
      iconfont: 'icon-ticket-tips3',
      color: 'title blue',
      value: statisticsSummary.transferre ?? 0,
      router: 'pending',
    },
    {
      layout: 'crosswise',
      title: '待审核',
      name: null,
      iconfont: 'icon-ticket-tips4',
      color: 'title blue',
      value: statisticsSummary.audit ?? 0,
      router: 'pendingReview',
    },
    {
      layout: 'lengthways',
      title: '',
      name: '平均响应时长',
      iconfont: '',
      color: '',
      // color: 'icon-down-to-up',
      value: `${statisticsSummary.resp ?? 0}min`,
      router: '',
    },
    {
      layout: 'lengthways',
      title: '',
      name: '平均处理时长',
      iconfont: '',
      color: '',
      // color: 'icon-up-to-down',
      value: `${statisticsSummary.deal ?? 0}min`,
      router: '',
    },
    {
      layout: 'lengthways',
      title: '',
      name: '工单完成率',
      iconfont: '',
      color: '',
      // color: 'icon-down-to-up',
      value: `${statisticsSummary.complete ?? 0}%`,
      router: '',
    },
  ];
};

const statisticsSummary = computed(() => store.state.ticket.statisticsSummary);
const customDate = computed(() => store.state.ticket.customDate);
const userInfo = computed(() => store.state.login.userInfo);

watch(statisticsSummary, (val) => {
  setOption(val);
});

store.dispatch('ticket/summaryOfWorkOrder', {
  startTime: moment(customDate.value[0]).format('YYYY-MM-DD'),
  endTime: moment(customDate.value[1]).format('YYYY-MM-DD'),
});

watch(customDate, (val) => {
  store.dispatch('ticket/summaryOfWorkOrder', {
    startTime: moment(val[0]).format('YYYY-MM-DD'),
    endTime: moment(val[1]).format('YYYY-MM-DD'),
  });
});

const handlerClick = (path: string) => {
  if (!path) {
    return;
  }
  let status: any = [];

  if (path === 'all') {
    status = [1,
      2,
      3,
      4,
      5,
      6,
      7,];
  }
  if (path === 'toBeAssigned') {
    status = [1,];
  }
  if (path === 'pending') {
    status = [2,
      3,
      4,
      5,];
  }
  if (path === 'pendingReview') {
    status = [5,];
  }
  router.push(
    `/logged/ticket/strokeList?status=${status.join(
      ','
    )}&dateSelect=${customDate.value.join(',')}`
  );
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (cur, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: idx,
          class: _normalizeClass(['content-block', cur.layout])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass([cur.layout === 'crosswise' ? 'left-block' : 'top-block'])
          }, [
            _withDirectives((_openBlock(), _createElementBlock("svg", _hoisted_4, [
              _createElementVNode("use", {
                "xlink:href": `#${cur.iconfont}`
              }, null, 8, _hoisted_5)
            ], 512)), [
              [_vShow, cur.iconfont]
            ]),
            _createElementVNode("span", null, _toDisplayString(cur.name ? cur.name : ""), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass([cur.layout === 'crosswise' ? 'right-block' : 'bottom-block'])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass([cur.color, 'iconfont']),
              onClick: ($event: any) => (handlerClick(cur.router))
            }, _toDisplayString(cur.title), 11, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(cur.value), 1)
          ], 2)
        ], 2))
      }), 128))
    ])
  ]))
}
}

})